<div class='table-responsive'>
  <table mat-table [dataSource]="changes" class="mat-elevation-z8">
    <ng-container matColumnDef="text" >
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.DOCUMENT'|translate}}</th>
      <td mat-cell *matCellDef="let element"> <a [routerLink]="getRoute(element)">{{element.text}}</a> </td>
    </ng-container>

    <ng-container matColumnDef="isNew">
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.NEW'|translate}}</th>
      <td mat-cell *matCellDef="let element"> <a [routerLink]="getRoute(element)">{{element.isNew}} </a></td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.STATUS'|translate}}</th>
      <td mat-cell *matCellDef="let element"> <a [routerLink]="getRoute(element)">{{'ENUMCHANGESTATE.' + element.status |translate}} </a> </td>
    </ng-container>

    <ng-container matColumnDef="docStatus">
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.DOCSTATUS'|translate}}</th>
      <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> <ldw-status-label [status]="element.docStatus"></ldw-status-label></a> </td>
    </ng-container>

    <ng-container matColumnDef="info">
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.INFO'|translate}}</th>
      <td mat-cell *matCellDef="let element"> <a [routerLink]="getRoute(element)">{{element.info}} </a></td>
    </ng-container>

    <ng-container matColumnDef="computer">
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.COMPUTER'|translate}}</th>
      <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> {{element.computer}} </a></td>
    </ng-container>

    <ng-container matColumnDef="changedBy">
      <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.CHANGEDBY'|translate}}</th>
      <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> {{element.user}} </a></td>
    </ng-container>

    <ng-container matColumnDef="changed">
      <th mat-header-cell *matHeaderCellDef>{{'DOCUMENT.CHANGEDATE'|translate}}</th>
      <td mat-cell *matCellDef="let element"> <a [routerLink]="getRoute(element)">{{element.date}} </a></td>
    </ng-container>

    <ng-container matColumnDef="project">
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.PROJECT'|translate}}</th>
      <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)">{{element.project}}</a> </td>
    </ng-container>

    <ng-container matColumnDef="path">
      <th mat-header-cell *matHeaderCellDef>{{'CHANGES.PATH'|translate}}</th>
      <td mat-cell *matCellDef="let element"><a [routerLink]="getRoute(element)"> {{element.path}} </a></td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
